export function extractIdentityDigits(value: string): string {
  return value.replace(/\D/g, "").slice(0, 11);
}

/** Bos = gecerli; doluysa tam 11 hane. */
export function validateTurkishIdentityNo(digits: string): string | null {
  if (!digits) return null;
  if (digits.length !== 11) {
    return `TC kimlik numarasi 11 haneli olmalidir (${digits.length} hane girdiniz).`;
  }
  return null;
}
